export default __webpack_public_path__ + "331418da4b4cb683dd64d6060fc5f2fe.jpg";